import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
// Components
import TestimonialBox from "../Elements/TestimonialBox";

export default function TestimonialSlider() {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div>
  <Slider {...settings}>
    <LogoWrapper className="flexCenter">
      <TestimonialBox
        text="La formation a été une véritable révélation pour moi ! Grâce aux cours interactifs et aux exercices pratiques, j’ai pu rapidement monter en compétences."
        author="Koffi KOUASSI"
      />
    </LogoWrapper>
    <LogoWrapper className="flexCenter">
      <TestimonialBox
        text="Un programme riche et structuré qui m’a permis de développer de nouvelles compétences professionnelles. Je recommande vivement !"
        author="Marie KOUADIO"
      />
    </LogoWrapper>
    <LogoWrapper className="flexCenter">
      <TestimonialBox
        text="Grâce à cette formation, j’ai pu décrocher un emploi dans mon domaine de prédilection. L’accompagnement des formateurs est exceptionnel !"
        author="Cyrille KAMGA"
      />
    </LogoWrapper>
    <LogoWrapper className="flexCenter">
      <TestimonialBox
        text="Un excellent programme qui allie théorie et pratique. J’ai particulièrement apprécié les études de cas qui nous préparent aux défis réels du marché du travail."
        author="Valery KAMGA"
      />
    </LogoWrapper>
    <LogoWrapper className="flexCenter">
      <TestimonialBox
        text="Je suis impressionné par la qualité des ressources pédagogiques et la disponibilité des formateurs. Une formation qui vaut vraiment le détour !"
        author="Fernand KODJO"
      />
    </LogoWrapper>
    <LogoWrapper className="flexCenter">
      <TestimonialBox
        text="Les cours sont clairs, précis et très bien expliqués. J’ai acquis des compétences solides qui me permettent d’être plus compétitif sur le marché du travail."
        author="Herve ILLOU"
      />
    </LogoWrapper>
  </Slider>
</div>

  );
}

const LogoWrapper = styled.div`
  width: 90%;
  padding: 0 5%;
  cursor: pointer;
  :focus-visible {
    outline: none;
    border: 0px;
  }
`;
